// 路由配置
import Vue from 'vue'
import VueRouter from 'vue-router'
import { ROUTE_PATHS, ROUTE_NAMES } from '@/utils/constants'

Vue.use(VueRouter)

const routes = [
  {
    path: ROUTE_PATHS.HOME,
    name: ROUTE_NAMES.HOME,
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      title: '健康诊断报告'
    }
  },
  {
    path: ROUTE_PATHS.HEALTH_ASSESSMENT,
    name: ROUTE_NAMES.HEALTH_ASSESSMENT,
    component: () => import(/* webpackChunkName: "health-assessment" */ '@/views/HealthAssessment.vue'),
    meta: {
      title: '健康评估'
    }
  },
  {
    path: ROUTE_PATHS.PSYCHOLOGICAL_AGE,
    name: ROUTE_NAMES.PSYCHOLOGICAL_AGE,
    component: () => import(/* webpackChunkName: "psychological-age" */ '@/views/PsychologicalAge.vue'),
    meta: {
      title: '生理年龄'
    }
  },
  {
    path: ROUTE_PATHS.TONGUE_DIAGNOSIS,
    name: ROUTE_NAMES.TONGUE_DIAGNOSIS,
    component: () => import(/* webpackChunkName: "tongue-diagnosis" */ '@/views/TongueDiagnosis.vue'),
    meta: {
      title: '舌诊检测'
    }
  },
  {
    path: ROUTE_PATHS.PULSE_DIAGNOSIS,
    name: ROUTE_NAMES.PULSE_DIAGNOSIS,
    component: () => import(/* webpackChunkName: "pulse-diagnosis" */ '@/views/PulseDiagnosis.vue'),
    meta: {
      title: '脉诊检测'
    }
  },
  {
    path: ROUTE_PATHS.HEALTH_SERVICE,
    name: ROUTE_NAMES.HEALTH_SERVICE,
    component: () => import(/* webpackChunkName: "health-service" */ '@/views/HealthService.vue'),
    meta: {
      title: '健康服务'
    }
  },
  {
    path: '*',
    redirect: ROUTE_PATHS.HOME
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

export default router

